import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Streamingpackage } from '../../../../interfaces/StreamingProvider.interface';
import usePreferredFilter from '../../../../zustand/Filter';
import Cheapestprice from './sections/Cheapestprice';
import { computeBestPrice } from './util/computeBestPrice';
import PriceTableBody from './sections/PriceTableBody';

type BCPriceTableProps = {
  providers: Streamingpackage[];
  isShowCheapeastActive: boolean;
  showSorted: boolean;
  showWithIcons?: boolean;
};

const BCPriceTable: React.FC<BCPriceTableProps> = ({
  providers,
  isShowCheapeastActive,
  showSorted,
  showWithIcons = false,
}) => {
  const { isMonthlySubscriptionPrefered } = usePreferredFilter();
  const totalGreenPrice = computeBestPrice(
    providers,
    isMonthlySubscriptionPrefered
  );

  return (
    <Box sx={{ marginBottom: 4 }}>
      <Cheapestprice
        isShowCheapeastActive={isShowCheapeastActive}
        totalGreenPrice={totalGreenPrice}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Provider</TableCell>
              <TableCell>Monthly Abonnement</TableCell>
              <TableCell>Yearly Abonnement</TableCell>
            </TableRow>
          </TableHead>
          <PriceTableBody
            isMonthlySubscriptionPrefered={isMonthlySubscriptionPrefered}
            isShowCheapeastActive={isShowCheapeastActive}
            providers={providers}
            showSorted={showSorted}
            showWithIcons={showWithIcons}
          />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BCPriceTable;
